<template>
  <div id="app" class="container">
    <div id="nav" class="menu p-2 navbar navbar-dark bg-dark img-wrap" >
        
      <img src="@/assets/logo_sch.png" high='24' width='24' alt="">

        <button @click="gotoMain" class="btn btn-dark">Principal</button>
        <button @click="gotoDocumentacion" class="btn btn-dark">Documentacion</button>
        <button @click="gotoHistorico" class="btn btn-dark">Históricos</button>
        <div class="d-fles">
          <button @click="destroyConnection" class="btn btn-dark">Logout</button>
        </div>
    </div>
    <div class="hora">
      <span v-if="necesitaDatos">{{ultimaHora}} -- <b>{{temperatura_exterior}}ºC</b></span>
      <!-- <span v-if="$route.name=='Documentacion'">Documentación</span>
      <span v-if="$route.name=='Historico'">Históricos</span> -->
    </div> 

    <hr>
    <div class="padre">
      <v-app>
        <router-view @credentials="fromLogin" @in_login="in_login" :client="client" :estados="estados"/>
      </v-app>
    </div>
    <div class="indicator">
      <img :src="mosquitto_connected"  width="32px" height="32px"/>
    </div>
  </div>
</template>
<script>
import mqtt from 'mqtt'
import padLeadingZeros from './Tools/numberTools'
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['potencia_inmovil']),
    estadosTratados(){

    },
    // temperatura_exterior()
    // {
    //   let res=''
    //   try {
    //     res = this.estados.temperatura_exterior.toFixed(2);
    //   } catch (error) {
        
    //   }
    //   return res
    // },
    mosquitto_connected() {

      return (this.client.connected)? require("@/assets/connected.png"):require("@/assets/disconnected.png");
    },
    necesitaDatos(){

      return((this.$route.name=='Home') || ((!this.$route.name.includes('documentacion')) && (!this.$route.name.includes('historico'))))
    }
  },
  data() {
    return {
      temperatura_exterior:null,
      ultimaHora:'',
      escuchandoMensajes:false,
      estados:{

      },
      has_error: false,
      client:{
        connected: false,
      },
      connection: {
      
        host: process.env.VUE_APP_IP,

        // port: 9002,
        port:  process.env.VUE_APP_MQTT_PORT,
        endpoint: '/mqtt',
        clean: true, // Reserved session
        connectTimeout: 4000, // Time out
        reconnectPeriod: 4000, // Reconnection interval
        // Certification Information
        // clientId: 'mqttjs_3be2c321',
        username: null,
        password: null,
      },
    };
   },
   created(){
     if(!this.client.connected){
       this.escuchandoMensajes=false;
       console.log("No estaba conectado y lo va a intentar...")
       if(localStorage.username){
        const credentials={
          username:localStorage.username,
          password:localStorage.password,
        }

        this.createConnection(credentials);

      }

     }else{
         console.log("Ya estaba conectado")

     }
   },

   

  methods: {
    ...mapActions(['setPotenciaInmovil']),
    destroyConnection() {
        localStorage.username='';
        localStorage.password='';
        this.connection.username=localStorage.username;
        this.connection.password=localStorage.password;
        if (this.client.connected) {

            try {

                this.client.end()
                this.client = {
                    connected: false,
                }
                this.escuchandoMensajes=false;
                console.log('Successfully disconnected!');


            } catch (error) {
                console.log('Disconnect failed', error.toString())
            }
        }
        console.log("el nombre es",this.$route.name)

        this.customSuscribe('potencia_inmovil')
        if(this.$route.name!='Login') this.$router.push({name:"Login"})
    },

    //Al entrar en login hay que cerrar la sesión
    in_login(){
        this.destroyConnection();
    },
    fromLogin(credentials){
        this.connection.username=credentials.username;
        this.connection.password=credentials.password;
        if(!this.client.connected) this.createConnection(credentials)
        else this.$router.push('/');
    },
    gotoMain(){
        if(this.$route.name!='Home')this.$router.push('/');
    },
    gotoDocumentacion(){
        if(this.$route.name!='Documentacion')this.$router.push('/documentacion');
    },
    gotoHistorico(){
      if(this.$route.name!='Historico')this.$router.push('/historico');
    },
    recepcion(message){
      //console.log(message);
         if( message.hasOwnProperty('estado1')){
           let currentState = {
              'estado1':message.estado1,
              'estado2':message.estado2,
              'estado3':message.estado3,
              'estado4':message.estado4,
              'estado5':message.estado5,
              'estado6':message.estado6,
              'estado7':message.estado7,
              'estado8':message.estado8,
              'estado10':message.estado10,
            }
            this.estados=currentState;
            console.log(this.estados);

         }
          if( message.hasOwnProperty('temperatura_exterior')){
            this.temperatura_exterior=message.temperatura_exterior.toFixed(2)
            //console.log('tiene temperatura exterior',message);
            if(Object.keys(message).length>1)this.estados=message;
          }
          else{
            //console.log(message);
            // potencia_parada
            this.estados=message;
          }
    },
    timeout(){
      this.ultimaHora='Sin datos'
    },
    getDatetime(){
      let date_ob = new Date();

      // adjust 0 before single digit date
      let date = ("0" + date_ob.getDate()).slice(-2);

      // current month
      let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

      // current year
      let year = date_ob.getFullYear();

      // current hours
      let hours = date_ob.getHours();

      // current minutes
      let minutes = date_ob.getMinutes();

      // current seconds
      let seconds = date_ob.getSeconds();

      return `${year}-${month}-${date} ${padLeadingZeros(hours,2)}:${padLeadingZeros(minutes,2)}:${padLeadingZeros(seconds,2)}`;

    },
    createConnection(credentials){

      this.connection.username=credentials.username;
      this.connection.password=credentials.password;
      let ok=false;
      const { host, port, endpoint, ...options } = this.connection
      //    const connectUrl = `ws://${host}:${port}${endpoint}`
      const connectUrl = `${process.env.VUE_APP_MQTT_PROTOCOL}://${host}:${port}`
      
      try {
          this.client = mqtt.connect(connectUrl, options)
      } catch (error) {
          console.log('mqtt.connect error', error)
      }
      this.client.on('connect', () => {
        let myTimeout = setTimeout(this.timeout, 5000);


        this.conectado=true;
        console.log('Connection succeeded!');
        localStorage.username=this.connection.username;
        localStorage.password=this.connection.password;
        console.log(this.$route.name);
        if(!this.escuchandoMensajes){
          console.log("No estaba escuchando mensajes")
          this.escuchandoMensajes=true;
          this.client.on('message', (topic, message) => {
            clearTimeout(myTimeout);
            myTimeout = setTimeout(this.timeout, 5000);
            
            this.ultimaHora = this.getDatetime();


            //console.log("Desde App")
            if(topic=='potencia_inmovil'){
              console.log('potencia_inmovil')
              console.log(message)
              const msg = JSON.parse(message);
              console.log(msg)
              this.setPotenciaInmovil(msg.alarm)
              
              return;
            }

            const msg = JSON.parse(message);
            this.recepcion(msg);
        })
        }

        if(this.$route.name=='Login')this.$router.push('/');


      })
    },


    customSuscribe(topic){
            console.log("Custom suscribe")
            this.client.subscribe(topic, 0, (error, res) => {
                if (error) {
                console.log('Subscribe to topics error', error)
                return
                }
                this.subscribeSuccess = true

                
                console.log('Subscribe to topics res', topic)
               
                this.customPublish('potencia')
            })
        },
        
        customPublish(topic_a){
            console.log("intento publicar")
            
            let publish = {
                topic: topic_a,
                qos: 0,
                payload: '{ "msg": "Hello, I am browser." }',
            }

            const { topic, qos,payload } = publish

            this.client.publish(topic, payload, [qos], error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        },


  },
}
</script>

<style>
.menu{
    position: absolute;
    height: 10%;
    width: 100%;
    top:0px;
    left:0px;
}
.indicator{
    position: absolute;
    top:11%;
    right:1%;
    z-index: 1;
}
.hora{
  position: absolute;
    top:11%;
    left:1%;
    padding: 2px;
    z-index: 1;
}
.indicadores{
  top:10%;
  width: 100%;
  height: 10%;
}
.padre{
    top:15%;
    left:0px;
    position: absolute;
    height: 80%;
    width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
